import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  menu: {
    backgroundColor: '#f7f6e7',
    color: '#314e52'
  },
  button: {
    "&:hover": {
      background: 'none',
      color: '#f2a154',
    },
  }
}));

export default function Menu() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0} className={classes.menu}>
        <Toolbar variant="dense">
          <Button color="inherit" className={classes.button} href=".">Gattino Lab LLC</Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}